module.exports = __webpack_public_path__ + "static/media/logo-numera-light.9bd54336.svg";